import domReady from '@wordpress/dom-ready';

domReady(function () {
	document.querySelectorAll('.hero-one').forEach((element) => {
		// Define the gradient overlay
		const gradient = 'var(--wp--preset--gradient--tbr-gradient-hero)';

		// Get the existing background image
		const bgImage = window.getComputedStyle(element).backgroundImage;

		// Combine the gradient and the background image
		element.style.backgroundImage = `${gradient}, ${bgImage}`;
	});
});
